import React from 'react';
import ProjectBox from './ProjectBox';
import StakeInspectorImg from '../images/stake-inspector.png';
import SeekTuneImg from '../images/seek-tune.png';
import SportfolioImg from '../images/sportfolio.png';
import Os_TelemetryImg from '../images/Os-Telemetry.png';
import LeetPrepImg from '../images/LeetPrep.png';

const Projects = () => {
  const projectData = [
    {
      projectPhoto: LeetPrepImg,
      projectName: "LeetPrep",
      description: "Built a Model Context Protocol server integrated with Claude Desktop to deliver personalized LeetCode coaching, tracking progress across 22 DSA patterns with SQLite persistence",
      techStack: "Python, MCP, SQLite, LangChain, Claude Desktop",
      githubLink: "https://github.com/VishnuDevi123/leetprep-mcp",
    },
    {
      projectPhoto: StakeInspectorImg,
      projectName: "Stake-Inspector (EtherFi Pool Prize Winners)",
      description: "Staking insights platform analyzing wallet activity and staking flows with model-driven recommendations and ZK-backed data integrity.",
      techStack: "FastAPI, Web3.py, Next.js, RandomForest, FinBERT, Zero-Knowledge proofs",
      githubLink: "https://github.com/likeMike001/project-inspector",
      devpost: "https://devpost.com/software/project-001-x4fqh9?ref_content=my-projects-tab&ref_feature=my_projects"
    },
    {
      projectPhoto: SeekTuneImg,
      projectName: "Seek-Tune",
      description: "AI music identification platform with in-browser WASM DSP fingerprinting and Go backend hashing/matching plus conversational recommendations.",
      techStack: "WASM, Go, FFmpeg, Mastra (TypeScript), Docker",
      githubLink: "https://github.com/VishnuDevi123/Wazam",
      devpost: ""
    },
    {
      projectPhoto: SportfolioImg,
      projectName: "Sportfolio — HackGT 12 (Honorable Mention)",
      description: "Fantasy-sports “stock market” app; integrated NBA JSON API data (1500+ games, 10k+ stats) into MongoDB, predictive analytics with pandas, and FastAPI + Redis caching to cut API failures by 60%.",
      techStack: "React, Node.js, MongoDB, Express, TypeScript, FastAPI, Redis, pandas",
      githubLink: "https://github.com/camero1993/hackGT-prizepix",
      devpost: "https://devpost.com/software/sportfolio-bgdc62"
    },
    {
      projectPhoto: Os_TelemetryImg,
      projectName: "Os-Telemetry",
      description: "A personal study focused on performance and memory tradeoffs between quantized GGUF models (Q4 vs Q8)",
      techStack: "Python, Shell, GGUF, Apple Metal, LLama.cpp, matplotlib",
      githubLink: "https://github.com/VishnuDevi123/OsTelemetry.git",
      devpost: ""
    },
    {
      id: "more-projects",
      projectPhoto: null, // IMPORTANT: null instead of ''
      projectName: "More Projects",
      description: "To view more of my projects, visit my GitHub profile.",
      techStack: "",
      githubLink: "https://github.com/VishnuDevi123",
      devpost: "",
    }
  ];


  return (
    <div>
      <h1 className='projectHeading'>My <b>Projects</b></h1>
      <div className='project'>
        {projectData.map((project) => (
          <ProjectBox
            key={project.id}
            projectPhoto={project.projectPhoto}
            projectName={project.projectName}
            description={project.description}
            githubLink={project.githubLink}
            devpost={project.devpost}
            techStack={project.techStack}
          />
        ))}
      </div>

    </div>
  )
}

export default Projects
